import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b8ecb21"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "multiselect-tag",
  tabindex: "-1"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "multiselect-tag-remove-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Multiselect = _resolveComponent("Multiselect", true)!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Multiselect, _mergeProps(_ctx.$attrs, {
      ref: "multiselect",
      noOptionsText: "Listen er tom",
      noResultsText: "Ingen resultat etter søket",
      class: "multiselect"
    }), {
      caret: _withCtx(() => [
        _createVNode(_component_SvgIcon, {
          type: "mdi",
          path: _ctx.caretIcon
        }, null, 8, ["path"])
      ]),
      tag: _withCtx(({option}) => [
        _createElementVNode("span", _hoisted_1, [
          _createTextVNode(_toDisplayString(option.label) + " ", 1),
          _createElementVNode("span", {
            class: "multiselect-tag-remove",
            onClick: ($event: any) => (_ctx.removeTag(option))
          }, [
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_SvgIcon, {
                class: "clear-tag-icon",
                type: "mdi",
                path: _ctx.clearIcon,
                height: "0.8rem",
                width: "0.8rem"
              }, null, 8, ["path"])
            ])
          ], 8, _hoisted_2)
        ])
      ]),
      clear: _withCtx(() => [
        _createVNode(_component_SvgIcon, {
          onMousedown: _ctx.clear,
          class: "clear-icon",
          type: "mdi",
          path: _ctx.clearIcon
        }, null, 8, ["onMousedown", "path"])
      ]),
      spinner: _withCtx(() => [
        _createVNode(_component_SvgIcon, {
          class: "loading-icon animate-spin",
          type: "mdi",
          path: _ctx.loadingIcon
        }, null, 8, ["path"])
      ]),
      _: 1
    }, 16)
  ]))
}